import React from 'react';
import {Navigate} from 'react-router-dom';

import {hooks} from '../hooks';
import {RootState} from '../store';

type Props = {
  children: React.ReactNode;
};

export const ProtectedRoute: React.FC<Props> = ({children}) => {
  const {authSlice} = hooks.useAppSelector((state: RootState) => state);

  // Jika tidak ada accessToken atau belum authenticated, redirect ke SignIn
  if (!authSlice.accessToken || !authSlice.isAuthenticated) {
    return <Navigate to='/SignIn' replace />;
  }

  return <>{children}</>;
};
